import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import FadeInFadeOutLi from '../../../components/merchant/components/Common/FadeInFadeOutLi';
import './QueueNumberFab.scss'
import QueueNumberPageItemRepository from '../Repository/QueueNumberPageItemRepository';
import { QUEUE_NUMBER_PAGE_FONT_SIZE_LS_KEY,            QUEUE_NUMBER_PAGE_DEFAULT_FONT_SIZE,            QUEUE_NUMBER_PAGE_FONT_SIZE_EVENT_CHANGED,
        QUEUE_NUMBER_PAGE_TITLE_FONT_SIZE_LS_KEY,       QUEUE_NUMBER_PAGE_TITLE_DEFAULT_FONT_SIZE,      QUEUE_NUMBER_PAGE_TITLE_FONT_SIZE_EVENT_CHANGED,
        QUEUE_NUMBER_PAGE_LINE_HEIGHT_LS_KEY,           QUEUE_NUMBER_PAGE_DEFAULT_LINE_HEIGHT,          QUEUE_NUMBER_PAGE_LINE_HEIGHT_EVENT_CHANGED,
        QUEUE_NUMBER_PAGE_AUDIO_REPEAT_COUNT_LS_KEY,    QUEUE_NUMBER_PAGE_DEFAULT_AUDIO_REPEAT_COUNT,   QUEUE_NUMBER_PAGE_AUDIO_REPEAT_COUNT_EVENT_CHANGED,
        QUEUE_NUMBER_PAGE_AUDIO_ENABLED_LS_KEY,         QUEUE_NUMBER_PAGE_DEFAULT_AUDIO_ENABLED,        QUEUE_NUMBER_PAGE_AUDIO_ENABLED_EVENT_CHANGED,
        QUEUE_NUMBER_PAGE_SHOW_TABLE_NAME_LS_KEY,       QUEUE_NUMBER_PAGE_DEFAULT_SHOW_TABLE_NAME,      QUEUE_NUMBER_PAGE_SHOW_TABLE_NAME_EVENT_CHANGED,
        QUEUE_NUMBER_PAGE_AUDIO_SPEED_LS_KEY,           QUEUE_NUMBER_PAGE_DEFAULT_AUDIO_SPEED,          QUEUE_NUMBER_PAGE_AUDIO_SPEED_EVENT_CHANGED,
        QUEUE_NUMBER_PAGE_AUDIO_WAIT_LS_KEY,            QUEUE_NUMBER_PAGE_DEFAULT_AUDIO_WAIT,           QUEUE_NUMBER_PAGE_AUDIO_WAIT_EVENT_CHANGED,
        QUEUE_NUMBER_PAGE_AUDIO_SETTING_EVENT_CHANGED,        } from './QueueNumberPage';
import AccessLevel from '../../../components/merchant/AccessLevel';
import TableSessionHelper from '../../../Model/TableSession';
import { getAudioSetting, NUMBER_AUDIO_PLAYER_PLAY_AUDIO, saveAudioSetting } from './Audio/NumberAudioPlayer';
import ReactHelper from '../../../util/ReactHelper';
import PrinterManagerHelper from '../Helper/PrinterManager/PrinterManagerHelper';
import PlainDiv from '../../../components/widget/PlainDiv';
import PinLogin from '../PinLogin/PinLogin';

class QueueNumberPortal extends React.Component {
    constructor(props) {
        super(props);
        if ($('#queue-number-portal').length == 0) {
            let div = $('<div id="queue-number-portal" style="z-index: 50"></div>')
            $('body').append(div)
        }
        this.portalRoot = document.getElementById("queue-number-portal");
        this.el = document.createElement("div");
    }
    componentDidMount = () => {
        this.portalRoot.appendChild(this.el);
    };
    componentWillUnmount = () => {
        this.portalRoot.removeChild(this.el);
    };
    onClose = () => {}
    render() {
        const { children } = this.props;
        return ReactDOM.createPortal(children, this.el);
    }
}

const getAudioEnabled = () => {
    let value = window.localStorage.getItem(QUEUE_NUMBER_PAGE_AUDIO_ENABLED_LS_KEY)
    if (value === null) {
        return QUEUE_NUMBER_PAGE_DEFAULT_AUDIO_ENABLED
    }
    return value == 1
}
const getShowTableName = () => {
    let value = window.localStorage.getItem(QUEUE_NUMBER_PAGE_SHOW_TABLE_NAME_LS_KEY)
    if (value === null) {
        return QUEUE_NUMBER_PAGE_DEFAULT_SHOW_TABLE_NAME
    }
    return value == 1
}

export const getDefaultAudioSetting = () => {
    return {
        audio_speed     : QUEUE_NUMBER_PAGE_DEFAULT_AUDIO_SPEED,
        repeat_count    : QUEUE_NUMBER_PAGE_DEFAULT_AUDIO_REPEAT_COUNT,
        audio_enabled   : QUEUE_NUMBER_PAGE_DEFAULT_AUDIO_ENABLED,
        audio_wait      : QUEUE_NUMBER_PAGE_DEFAULT_AUDIO_WAIT,
    }
}
class QueueNumberFab extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: {},
            isShowSetting: false,
            showTableName: getShowTableName(),
            audioSettings: getAudioSetting(),
        }

        this.isLoading = {}
        this.callbackKey = "QueueNumberFab"

        this.queueNumberListRef = React.createRef()
    }
    componentDidMount = () => {
        QueueNumberPageItemRepository.getDefaultInstance().onThrottledResultByGroup(({ preparing, ready, queueNumberPageItems, }) => {
            let allActiveQueueNumbers = []
            for (let i = 0; i < preparing.length; i++) {
                allActiveQueueNumbers.push({
                    id: preparing[i].id,
                    queueNumber: preparing[i].queue_number,
                    tableSessionId: preparing[i].table_session_id,
                    isReady: false,
                })
            }
            for (let i = 0; i < ready.length; i++) {
                allActiveQueueNumbers.push({
                    id: ready[i].id,
                    queueNumber: ready[i].queue_number,
                    tableSessionId: ready[i].table_session_id,
                    isReady: true,
                })
            }
            allActiveQueueNumbers.sort((a, b) => parseInt(a.queueNumber) - parseInt(b.queueNumber))

            let setStateCallback = null

            // Try to load table and table session, if unsuccessful load it again later
            if (!this.getTableForQueueNumber(allActiveQueueNumbers)) {
                setStateCallback = this.getTableForQueueNumber
            }
            this.setState({
                preparing, ready, queueNumberPageItems, allActiveQueueNumbers
            }, setStateCallback)
        }, this.callbackKey, this)

        $(document).on(QUEUE_NUMBER_PAGE_SHOW_TABLE_NAME_EVENT_CHANGED, this.onShowTableNameChange)
        $(document).on(QUEUE_NUMBER_PAGE_AUDIO_SETTING_EVENT_CHANGED, this.handleAudioSettingChanged)
        window.addEventListener('storage', this.handleAudioSettingChanged)
    }
    componentWillUnmount() {
        QueueNumberPageItemRepository.getDefaultInstance().removeCallback(null, this)
        $(document).off(QUEUE_NUMBER_PAGE_SHOW_TABLE_NAME_EVENT_CHANGED, this.onShowTableNameChange)
        $(document).off(QUEUE_NUMBER_PAGE_AUDIO_SETTING_EVENT_CHANGED, this.handleAudioSettingChanged)
        window.removeEventListener('storage', this.handleAudioSettingChanged)
    }
    componentDidUpdate() {
        ReactHelper.handleComponentDidUpdate(this, ["sessions", "tables", {allActiveQueueNumbers: this.state.allActiveQueueNumbers}], () => {
            this.getTableForQueueNumber()
        })
    }
    handleAudioSettingChanged = () => {
        const audioSettings = getAudioSetting()
        if (JSON.stringify(audioSettings) !== JSON.stringify(this.state.audioSettings)) {
            this.setState({audioSettings})
        }
    }
    getTableForQueueNumber = (allActiveQueueNumbers) => {
        // If allActiveQueueNumbers provided, no need timer and direct modify the objects
        let needTimer = !allActiveQueueNumbers

        if (!this.props.app.state.tableSessionLoaded || !this.props.app.state.tablesLoaded) {
            return false
        }
        if (!allActiveQueueNumbers) {
            allActiveQueueNumbers = this.state.allActiveQueueNumbers
        }

        const handle = () => {
            (allActiveQueueNumbers || []).forEach(queueNumberItem => {
                const tableSessionId = queueNumberItem.tableSessionId
                const tableSession = TableSessionHelper.find(tableSessionId)
                if (tableSession) {
                    const table = this.props.app.state.tables.find(t => t.id == tableSession.table_id)
                    if (table) {
                        queueNumberItem.table = table
                    }
                }
            })
        }

        if (this.getTableTimer) {
            clearTimeout(this.getTableTimer)
        }
        if (needTimer) {
            this.getTableTimer = setTimeout(() => {
                handle()
            }, 200)
            return false
        }
        else {
            handle()
            return true
        }
    }
    onShowTableNameChange = () => {
        let newValue = getShowTableName()
        if (newValue != this.state.showTableName) {
            this.setState({
                showTableName: newValue,
            })
        }
    }
    /**
     * Toggle to show/hide PendingQueueDetail
     */
    fabClicked = () => {
        this.setState({
            isShowQueueNumberPageItems: !this.state.isShowQueueNumberPageItems
        })
    }
    showPendingQueueDetails = () => {
        this.setState({
            isShowQueueNumberPageItems: true
        })
    }
    hidePendingQueueDetails = () => {
        this.setState({
            isShowQueueNumberPageItems: false
        })
    }
    queueNumberSetReady = (tableSessionId, queueNumberPageItem, playAudio = true) => {
        this.isLoading[tableSessionId] = true
        const isLoading = {...this.isLoading}
        this.setState({isLoading})

        TableSessionHelper.setOrderReady({
            queueNumberPageItemId: queueNumberPageItem.id,
            tableSessionIds: [tableSessionId],
            isReady: true,
            isDineIn: true,
        })
        .then((res) => {

        })
        .finally(() => {
            this.isLoading[tableSessionId] = false
            const isLoading = {...this.isLoading}
            this.setState({isLoading})

            if (playAudio) {
                $(document).trigger(NUMBER_AUDIO_PLAYER_PLAY_AUDIO, [queueNumberPageItem.queueNumber])
            }
        })
    }
    playQueueNumberAudio = (queueNumber) => {
        if (queueNumber) {
            $(document).trigger(NUMBER_AUDIO_PLAYER_PLAY_AUDIO, [queueNumber])
        }
    }
    removeAllQueueNumber = () => {
        const { allActiveQueueNumbers = [], queueNumberPageItems} = this.state

        // Pass all table session ids all queueNumberPageItemIds
        this.queueNumberSetComplete(allActiveQueueNumbers.map(item => item.tableSessionId), queueNumberPageItems)
    }
    /**
     * Pass single tableSessionId to delete one item, pass arrays of tableSessionIds to delete multiple items
     * Do take note that for each tableSessionId, there might be multiple queueNumberPageItems related,
     * as queueNumber is show as ONE item for each tableSession, but actually consist multiple queueNumberItem where each item
     * correspond to ONE order item (there can be multiple order items in single table session)
     * 
     * @param {String} tableSessionId - int or arry of ints
     * @param {Array} queueNumberPageItem - Array of QueueNumberPageItem
     * @param {*} callback 
     */
    queueNumberSetComplete = (tableSessionId, queueNumberPageItems, callback) => {
        let tableSessionIds = null
        let apiPart = tableSessionId
        if (Array.isArray(tableSessionId)) {
            tableSessionIds = tableSessionId
            tableSessionIds.forEach(tableSessionId => {
                this.isLoading[tableSessionId] = true
            })
            apiPart = 'multi'
        }
        else {
            this.isLoading[tableSessionId] = true
        }
        
        const isLoading = {...this.isLoading}
        this.setState({isLoading})

        $.ajax({
            url     : `/merchant/api/table_sessions/${apiPart}/reclose_for_bill_exist`,
            type    : 'post',
            contentType: 'application/json',
            processData: false,
            data    : JSON.stringify({
                table_session_ids: tableSessionIds,
                queue_number_page_item_ids: queueNumberPageItems && queueNumberPageItems.length ? queueNumberPageItems.map(item => item.id) : null
            }),
            success : (res) => {
                callback && callback(tableSessionIds || tableSessionId)
            },
        })
        .always(() => {
            if (tableSessionIds) {
                // Multiple table session
                tableSessionIds.forEach(tableSessionId => {
                    this.isLoading[tableSessionId] = false
                })
            }
            else {
                // Single table session
                this.isLoading[tableSessionId] = false
            }
            const isLoading = {...this.isLoading}
            this.setState({isLoading})
        })
    }
    toggleSetting = () => {
        this.setState({isShowSetting: !this.state.isShowSetting}, () => {
            if (this.state.isShowSetting) {
                setTimeout(() => {
                    $(this.queueNumberListRef.current).animate({'scrollTop': 0})
                }, 300);
            }
        })
    }

    render() {
        if (!PinLogin.isLoggedIn()) {
            return null
        }
        return (
            this.props.usePortal ? <QueueNumberPortal>
                {this.getBody()}
            </QueueNumberPortal> :
            <div>
                {this.getBody()}
            </div>
        )
    }
    getBody = () => {
        const { isShowQueueNumberPageItems, isShowFab = true, allActiveQueueNumbers, isShowSetting, isLoading, showTableName, audioSettings } = this.state
        return (
            <>
                <div onClick={this.fabClicked} style={{display: isShowFab ? "table" : "none",height:"40px", width:"40px", backgroundColor:"rgb(220, 0, 78)", boxShadow: "0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)", borderRadius:"50%", textAlign:"center", verticalAlign:"middle"}}>
                    <div style={{display:"table-cell",verticalAlign:"middle", color:"white"}}>
                        <div><i className="fa fa-columns"/></div>
                    </div>
                </div>
                {
                    !isShowQueueNumberPageItems ? null :
                    <div className="queue-number-listing-wrapper" style={{display: isShowQueueNumberPageItems ? "block" : "none",}}>
                        <div className="card" style={{width:"250px"}} >
                            <div style={{display: "flex", marginBottom: "4px"}}>
                                {
                                    AccessLevel.isSuperAdmin() &&
                                    <span style={{marginTop: "auto", marginBottom: "auto"}}>
                                        <i className="fa fa-cog" onClick={this.toggleSetting}/>
                                    </span>
                                }
                                {
                                    (allActiveQueueNumbers || []).length > 1 && <div style={{textAlign: "right", flex: "1 0 100px"}}>
                                        <button className="btn btn-sm btn-default" onClick={this.removeAllQueueNumber}>{lang.remove_all}</button>
                                    </div>
                                }
                            </div>

                            <ul ref={this.queueNumberListRef} className="list-group list-group-flush">
                                {
                                    isShowSetting && <FadeInFadeOutLi>
                                        <QueueNumberPageSetting />
                                    </FadeInFadeOutLi>
                                }
                                {
                                    (allActiveQueueNumbers || []).map(item => {
                                        return <FadeInFadeOutLi key={item.tableSessionId}>
                                            {item.queueNumber} {showTableName && item.table ? <span className="ml-2">{`(T.${item.table.name})`}</span> : ""}
                                            <span className="pull-right">
                                                {
                                                    isLoading[item.tableSessionId] ?
                                                    <i className="fa fa-spinner fa-spin" /> :
                                                    <>
                                                        <>
                                                            <button disabled={!audioSettings.audio_enabled} className="btn btn-default btn-sm" onClick={() => this.playQueueNumberAudio(item.queueNumber)}><i className="fa fa-volume-up"/></button>
                                                        </>
                                                        {
                                                            item.isReady &&
                                                            <>
                                                                <button className="btn btn-default btn-sm" onClick={() => this.queueNumberSetComplete(item.tableSessionId, item)}><i className="fa fa-trash text-danger"/></button>
                                                            </>
                                                        }
                                                        {
                                                            !item.isReady &&
                                                            <>
                                                                <button className="btn btn-default btn-sm" onClick={() => this.queueNumberSetReady(item.tableSessionId, item)}><i className="fa fa-check text-success"/></button>
                                                            </>
                                                        }
                                                    </>
                                                }
                                            </span>
                                        </FadeInFadeOutLi>
                                    })
                                }
                            </ul>
                        </div>
                    </div>
                }
            </>
        )
    }
}

class QueueNumberPageSetting extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showTableName       : getShowTableName(),
            audioSettings       : getAudioSetting(),
        }
    }
    componentDidMount() {
        window.addEventListener('storage', this.onLocalStorageChange)
        $(document).on(QUEUE_NUMBER_PAGE_AUDIO_SETTING_EVENT_CHANGED, this.onLocalStorageChange)
        $(document).on(QUEUE_NUMBER_PAGE_SHOW_TABLE_NAME_EVENT_CHANGED, this.onShowTableNameChange)
    }
    componentWillUnmount() {
        window.removeEventListener('storage', this.onLocalStorageChange)
        $(document).off(QUEUE_NUMBER_PAGE_AUDIO_SETTING_EVENT_CHANGED, this.onLocalStorageChange)
        $(document).off(QUEUE_NUMBER_PAGE_SHOW_TABLE_NAME_EVENT_CHANGED, this.onShowTableNameChange)
    }
    onLocalStorageChange = () => {
        const audioSettings = getAudioSetting()
        if (JSON.stringify(audioSettings) !== JSON.stringify(this.state.audioSettings)) {
            this.setState({audioSettings})
        }
    }
    onShowTableNameChange = () => {
        let newShowTableName = getShowTableName()
        if (newShowTableName != this.state.showTableName) {
            this.setState({
                showTableName: newShowTableName,
            })
        }
    }
    changeQueueNumberPageAudioRepeatCount = (operation) => {
        const newValue = this.handleQueueNumberPageSettingChange(
            QUEUE_NUMBER_PAGE_AUDIO_REPEAT_COUNT_LS_KEY,
            QUEUE_NUMBER_PAGE_DEFAULT_AUDIO_REPEAT_COUNT,
            QUEUE_NUMBER_PAGE_AUDIO_REPEAT_COUNT_EVENT_CHANGED,
            operation, {
                incrementMultiplier: 1,
                minValue: 1,
            })

        let audioSetting = getAudioSetting()
        audioSetting.repeat_count = newValue
        saveAudioSetting(audioSetting)
        PrinterManagerHelper.printerManagerUpdateAudioSetting(audioSetting)
    }
    changeQueueNumberPageAudioSpeed = (operation) => {
        let newValue = this.handleQueueNumberPageSettingChange(
            QUEUE_NUMBER_PAGE_AUDIO_SPEED_LS_KEY,
            QUEUE_NUMBER_PAGE_DEFAULT_AUDIO_SPEED,
            QUEUE_NUMBER_PAGE_AUDIO_SPEED_EVENT_CHANGED,
            operation, {
                incrementMultiplier: 1,    // Increment by 10 milisecond
                minValue: 1,
                maxValue: 10,
            })

        let audioSetting = getAudioSetting()
        audioSetting.audio_speed = newValue
        saveAudioSetting(audioSetting)
        PrinterManagerHelper.printerManagerUpdateAudioSetting(audioSetting)
    }
    changeQueueNumberPageAudioWait = (operation) => {
        let newValue = this.handleQueueNumberPageSettingChange(
            QUEUE_NUMBER_PAGE_AUDIO_WAIT_LS_KEY,
            QUEUE_NUMBER_PAGE_DEFAULT_AUDIO_WAIT,
            QUEUE_NUMBER_PAGE_AUDIO_WAIT_EVENT_CHANGED,
            operation, {
                incrementMultiplier: 1,    // Increment by 10 milisecond
                minValue: 1,
                maxValue: 10,
            })

        let audioSetting = getAudioSetting()
        audioSetting.audio_wait = newValue
        saveAudioSetting(audioSetting)
        PrinterManagerHelper.printerManagerUpdateAudioSetting(audioSetting)
    }
    changeQueueNumberPageAudioEnable = () => {
        let audioSetting = getAudioSetting()
        audioSetting.audio_enabled = !audioSetting.audio_enabled ? 1 : 0
        saveAudioSetting(audioSetting)
        PrinterManagerHelper.printerManagerUpdateAudioSetting(audioSetting)
    }
    changeQueueNumberShowTableName = () => {
        let lsKey = QUEUE_NUMBER_PAGE_SHOW_TABLE_NAME_LS_KEY
        let eventKey = QUEUE_NUMBER_PAGE_SHOW_TABLE_NAME_EVENT_CHANGED
        let newValue = !getShowTableName()
        localStorage.setItem(lsKey, newValue ? 1 : 0)
        $(document).trigger(eventKey, [newValue])
    }
    changeQueueNumberPageFontSize = (operation) => {
        this.handleQueueNumberPageSettingChange(
            QUEUE_NUMBER_PAGE_FONT_SIZE_LS_KEY,
            QUEUE_NUMBER_PAGE_DEFAULT_FONT_SIZE,
            QUEUE_NUMBER_PAGE_FONT_SIZE_EVENT_CHANGED,
            operation, {incrementMultiplier: 10, minValue: 10, maxValue: 1000})
    }
    changeQueueNumberPageTitleFontSize = (operation) => {
        this.handleQueueNumberPageSettingChange(
            QUEUE_NUMBER_PAGE_TITLE_FONT_SIZE_LS_KEY,
            QUEUE_NUMBER_PAGE_TITLE_DEFAULT_FONT_SIZE,
            QUEUE_NUMBER_PAGE_TITLE_FONT_SIZE_EVENT_CHANGED,
            operation, {incrementMultiplier: 10, minValue: 10, maxValue: 1000})
    }
    changeQueueNumberPageLineHeight = (operation) => {
        this.handleQueueNumberPageSettingChange(
            QUEUE_NUMBER_PAGE_LINE_HEIGHT_LS_KEY,
            QUEUE_NUMBER_PAGE_DEFAULT_LINE_HEIGHT,
            QUEUE_NUMBER_PAGE_LINE_HEIGHT_EVENT_CHANGED,
            operation, {
                incrementMultiplier: 0.05,
                minValue: 0.05,
                maxValue: 10,
            }
        )
    }

    handleQueueNumberPageSettingChange = (localStorageKey, defaultValue, eventKey, operation, options = {incrementMultiplier: 10, minValue: 0, maxValue: 100}) => {
        let currentFontSize = window.localStorage.getItem(localStorageKey)
        if (currentFontSize === null) {
            currentFontSize = defaultValue
        }

        // Increase/decrease font size by 10%, where operation should be 1 or -1
        let increment =  (operation < 0 ? -1 : 1) * options.incrementMultiplier
        let newValue = parseFloat(currentFontSize) + increment

        if (newValue < options.minValue && operation < 0 || newValue > options.maxValue && operation > 0) {
            newValue = currentFontSize // Revert back to current value
        }

        localStorage.setItem(localStorageKey, newValue)
        $(document).trigger(eventKey, [newValue])

        return newValue
    }
    render() {
        const { showTableName, audioSettings, } = this.state

        return (
            <>
                <div style={{display: "flex"}}>
                    <div style={{flex: "1 0 100px"}}>
                        <div>
                            {lang.queue_number}
                        </div>
                        <div>
                            <button className="btn btn-sm btn-default" onClick={() => this.changeQueueNumberPageFontSize(-1)}>
                                <span><i className="fa fa-font fa-sm"></i></span>
                            </button>
                            <button className="btn btn-sm btn-default" onClick={() => this.changeQueueNumberPageFontSize(1)}>
                                <span><i className="fa fa-font fa-lg"></i></span>
                            </button>
                        </div>
                    </div>
                    <div style={{flex: "1 0 100px", textAlign: "right"}}>
                        <div>
                            {lang.title}
                        </div>
                        <div>
                            <button className="btn btn-sm btn-default" onClick={() => this.changeQueueNumberPageTitleFontSize(-1)}>
                                <span><i className="fa fa-font fa-sm"></i></span>
                            </button>
                            <button className="btn btn-sm btn-default" onClick={() => this.changeQueueNumberPageTitleFontSize(1)}>
                                <span><i className="fa fa-font fa-lg"></i></span>
                            </button>
                        </div>
                    </div>
                </div>
                <div style={{display: "flex", marginTop: "10px"}}>
                    <div style={{flex: "1 0 100px"}}>
                        <div>
                            {lang.spacing}
                        </div>
                        <div>
                            <button className="btn btn-sm btn-default" onClick={() => this.changeQueueNumberPageLineHeight(-1)}>
                                <span><i className="fa fa-minus"/></span>
                            </button>
                            <button className="btn btn-sm btn-default" onClick={() => this.changeQueueNumberPageLineHeight(1)}>
                                <span><i className="fa fa-plus"/></span>
                            </button>
                        </div>
                    </div>

                    <div style={{flex: "1 0 100px", textAlign: "right"}}>
                        <div>
                            {lang.sound_repeat}
                        </div>
                        <div>
                            <button className="btn btn-sm btn-default" onClick={() => this.changeQueueNumberPageAudioRepeatCount(-1)}>
                                <span><i className="fa fa-minus"/></span>
                            </button>
                            <span style={{marginLeft: "5px", marginRight: "5px"}}>{audioSettings.repeat_count}</span>
                            <button className="btn btn-sm btn-default" onClick={() => this.changeQueueNumberPageAudioRepeatCount(1)}>
                                <span><i className="fa fa-plus"/></span>
                            </button>
                            <button className={`btn btn-sm btn-default ${audioSettings.audio_enabled ? "" : "bg-danger-50"}`} onClick={this.changeQueueNumberPageAudioEnable}>
                                <span><i className={`${audioSettings.audio_enabled ? "fa fa-volume-up": "fa fa-volume-mute"}`}/></span>
                            </button>
                        </div>
                    </div>
                </div>
                <div style={{display: "flex", marginTop: "10px"}}>
                    <div style={{flex: "1 0 100px"}}>
                        <div>
                            {lang.sound_speed}
                        </div>
                        <div>
                            <button className="btn btn-sm btn-default" onClick={() => this.changeQueueNumberPageAudioSpeed(-1)}>
                                <span><i className="fa fa-minus"/></span>
                            </button>
                            <span style={{marginLeft: "5px", marginRight: "5px"}}>{audioSettings.audio_speed}</span>
                            <button className="btn btn-sm btn-default" onClick={() => this.changeQueueNumberPageAudioSpeed(1)}>
                                <span><i className="fa fa-plus"/></span>
                            </button>
                        </div>
                    </div>
                    <div style={{flex: "1 0 100px", textAlign: "right"}}>
                        <div>
                            {lang.sound_wait}
                        </div>
                        <div>
                            <button className="btn btn-sm btn-default" onClick={() => this.changeQueueNumberPageAudioWait(-1)}>
                                <span><i className="fa fa-minus"/></span>
                            </button>
                            <span style={{marginLeft: "5px", marginRight: "5px"}}>{audioSettings.audio_wait}</span>
                            <button className="btn btn-sm btn-default" onClick={() => this.changeQueueNumberPageAudioWait(1)}>
                                <span><i className="fa fa-plus"/></span>
                            </button>
                        </div>
                    </div>
                </div>
                <div style={{display: "flex", marginTop: "10px"}}>
                    <div style={{flex: "1 0 100px"}}>
                    <div>
                            {lang.table_name}
                        </div>
                        <label className="switch">
                            <input name="out_of_stock" type="checkbox"
                                checked={showTableName}
                                onChange={this.changeQueueNumberShowTableName}/>
                            <span className="slider round"></span>
                        </label>
                    </div>
                </div>
            </>
        )
    }
}

export default QueueNumberFab;